HMultiStepNavigatorComponent.$inject = [];

function HMultiStepNavigatorComponent() {

    var self = this;
    var flattedSteps = [];
    var categorySteps = [];

    self.STEP_STATUS = {
        INITIAL: "INITIAL",
        ACTIVE: "ACTIVE",
        DANGER: "DANGER",
        WARNING: "WARNING",
        COMPLETED: "COMPLETED",
    };

    self.STEP_TYPE = {
        CATEGORY: 'CATEGORY',
        PHASE: 'PHASE',
    };

    /**
     * Handles the click event when a step is clicked.
     * Compares the code of the clicked step with the code of the active step,
     * and triggers the 'onStepChanged' event if they are different.
     * @param {Object} event - click event
     * @param {Object} clickedStep - The step that was clicked.
     * @returns {void}
     */
    self.onStepClicked = function (event, clickedStep) {
        event && event.stopPropagation();
        if (!self.disableStep && clickedStep.code !== self.activeStep.code) {
            self.onStepChanged({newStep: clickedStep});
        }
    };

    /**
     * Updates the statuses of steps based on the active step and the previous step.
     *
     * @param {Step} activeStep - The currently active step.
     * @param {Step} [previousStep] - The previously active step (optional).
     */
    var updateStepsStatuses = function (activeStep, previousStep) {
        var prevStepIndex;
        var activeStepIndex;
        self.activeStep = activeStep;

        if (self.activeStep && self.activeStep.status) {
            self.activeStep.status = self.STEP_STATUS.ACTIVE;
        }

        if (previousStep) {
            prevStepIndex = flattedSteps.findIndex(function (step) {
                return step.code === previousStep.code;
            });
        }

        if (self.activeStep) {
            activeStepIndex = flattedSteps.findIndex(function (step) {
                return step.code === self.activeStep.code;
            });
            flattedSteps[activeStepIndex].status = self.STEP_STATUS.ACTIVE;
        }

        if (self.customStatusOnNext) {
            return;
        }

        if (previousStep && prevStepIndex < activeStepIndex) {
            for (var i = prevStepIndex; i < activeStepIndex; i++) {
                if (flattedSteps[i] && (!self.multiLevel || flattedSteps[i].type !== self.STEP_TYPE.CATEGORY)) {
                    flattedSteps[i].status = self.STEP_STATUS.COMPLETED;
                }
            }
        } else if (previousStep && prevStepIndex > activeStepIndex) {
            for (var j = activeStepIndex + 1; j <= prevStepIndex; j++) {
                if (flattedSteps[j]) {
                    flattedSteps[j].status = self.STEP_STATUS.INITIAL;
                }
            }
        }

        if (!self.customStatusOnNext) {
            // Iterate through each category to check completion status.
            for (var c = 0; c < categorySteps.length; c++) {
                var category = categorySteps[c];

                var uncompletedPhases = flattedSteps.filter(function (step) {
                    return (step.parentCode === category.code && step.status !== self.STEP_STATUS.COMPLETED)
                });

                // If no uncompleted phases are found, mark the category as completed.
                if (!uncompletedPhases.length) {
                    category.status = self.STEP_STATUS.COMPLETED;
                }
            }
        }
    };

    /**
     * Flattens a hierarchical array of steps into a single-level array.
     *
     * @param {Array} steps - The array containing steps and categories.
     * @returns {Array} - A flat array containing all steps and phases.
     */
    var getFlattedStepsArr = function (steps) {
        var flattedArr = [];

        for (var i = 0; i < steps.length; i++) {
            flattedArr = flattedArr.concat(steps[i]);

            if (steps[i].type === self.STEP_TYPE.CATEGORY && steps[i].phases) {
                steps[i].phases.forEach(function (phase) {
                    phase.parentCode = steps[i].code;
                });
                flattedArr = flattedArr.concat(steps[i].phases);
                categorySteps.push(steps[i]);
            }
        }

        return flattedArr;
    };

    self.$onInit = function () {
        flattedSteps = self.steps;
        if (self.multiLevel) {
            flattedSteps = getFlattedStepsArr(self.steps);
        }
        updateStepsStatuses(self.activeStep);
    };

    self.$onChanges = function (changesObj) {
        if (
            !self.disableStep &&
            changesObj &&
            changesObj.activeStep &&
            !changesObj.activeStep.isFirstChange()
        ) {
            updateStepsStatuses(changesObj.activeStep.currentValue, changesObj.activeStep.previousValue);
        }
    };

    self.toggleStepsList = function () {
        self.expandStepper = !self.expandStepper;
    };
}

angular
    .module('components')
    .component("hMultiStepNavigator", {
        bindings: {
            steps: '<',
            activeStep: '<',
            disableStep: '<',
            customStatusOnNext: '<',
            multiLevel: '<',
            stepperLabel: '<',
            expandStepper: '<',
            customStatusOnNext: '<',
            verticalNavigator: '<',
            onStepChanged: '&',
            cssClass: '@',
        },
        controller: HMultiStepNavigatorComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-multi-step-navigator/h-multi-step-navigator.component.ng.html'
    });
